"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = require("underscore");

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = _interopRequireDefault(require("react-dnd-html5-backend"));

var _default = (0, _underscore.once)(function () {
  return (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend.default);
});

exports.default = _default;
module.exports = exports.default;